import { render, staticRenderFns } from "./avalonAppsElement.vue?vue&type=template&id=9de9744a&scoped=true&"
import script from "./avalonAppsElement.vue?vue&type=script&lang=js&"
export * from "./avalonAppsElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de9744a",
  null
  
)

export default component.exports